import Type from './Type';
export function isIModal(node) {
    return node.type === Type.Modal;
}
export default isIModal;    //# sourceMappingURL=isIModal.js.map
